import React from "react";
import { Link, useLocation } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink";
import ModuleHeader from "../components/ModuleHeader/ModuleHeader";

const menuItems = [
  {
    path: "/transport/report",
    title: "Transport Report",
    icon: "ri-file-chart-line",
    activePaths: ["/transport/report"],
  },
  {
    path: "/bus/list",
    title: "Bus List",
    icon: "ri-bus-line",
    activePaths: ["/bus/list"],
  },
  {
    path: "/roots/stops/list",
    title: "Roots Stops List",
    icon: "ri-map-pin-line",
    activePaths: ["/roots/stops/list", "/bus/stop/import"],
  },
  {
    path: "/bus/student/list",
    title: "Bus Student List",
    icon: "ri-group-line",
    activePaths: ["/bus/student/list", "/bus/students/import"],
  },
  {
    path: "/bus/live",
    title: "Bus Live Tracking",
    icon: "ri-map-pin-2-line",
    activePaths: ["/bus/live", "/bus/live/tracking"],
  },
  {
    path: "/bus/pass",
    title: "Bus Pass",
    icon: "ri-bank-card-line",
    activePaths: ["/bus/pass"],
  },
];

export default function Mater({ children }) {
  return ;
  const hasAccess = usePrivateLink();

  const visibleTabs = menuItems.filter((tab) => hasAccess(tab.path));

  return (
    <>
      <ModuleHeader tabs={visibleTabs} />
      {children}
    </>
  );
}

// export default function Master() {
//   const { pathname } = useLocation();
//   const hasAccess = usePrivateLink();

//   return (
//     <div className="col-12">
//       <div className="d-flex align-items-center gap-2 pb-5 overflow-auto">
//         {menuItems.map((item) => {
//           if (!hasAccess(item.path)) return null;

//           const isActive =
//             item.activePaths?.some(
//               (path) => pathname === path || pathname.startsWith(`${path}/`)
//             ) ?? pathname === item.path;

//           return (
//             <Link
//               key={item.path}
//               to={item.path}
//               className={`btn rounded-pill text-nowrap ${isActive ? "btn-primary" : "btn-outline-primary"
//                 }`}
//             >
//               <i className={`${item.icon} me-1`} />
//               <span>{item.label}</span>
//             </Link>
//           );
//         })}
//       </div>
//     </div>
//   );
// }
